<template>
    <div id="services">
        <v-alert
            class="mb-0"
            dense
            border="bottom"
            type="primary"
            icon="mdi-information"
            >SERVICES INFORMATION</v-alert
        >
        <v-card>
            <v-tabs
                v-model="active_tab"
                background-color="primary"
                center-active
                dark
            >
                <v-tab v-for="(item, index) in subcasedetail" :key="index"
                    >Sub 0{{ item.subcase }}</v-tab
                >

                <v-tab-item v-for="(item, index) in subcasedetail" :key="index">
                    <v-card-text class="pa-2">
                        <v-tooltip
                            top
                            v-if="
                                detailcase.project_name === 'ODM' ||
                                    team_name == 'ODM'
                            "
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    color
                                    fab
                                    small
                                    v-on="on"
                                    :to="
                                        '/Project/PrintODM/' +
                                            item.maincase_id +
                                            '/' +
                                            item.subcase_id
                                    "
                                    target="_blank"
                                >
                                    <v-icon>mdi-fax</v-icon>
                                </v-btn>
                            </template>
                            <span>Print</span>
                        </v-tooltip>
                        <!-- docnonhp -->
                        <v-tooltip
                            top
                            v-if="
                                detailcase.project_name ==
                                    'Thailand Post (PO)' ||
                                    detailcase.project_name ==
                                        'Thailand Post (PO) TRACK & TRACE' ||
                                    detailcase.project_name ==
                                        'Thailand POST (PO)_สป(ส)70/2565' ||
                                    detailcase.project_name ==
                                        'Thailand POST_702565' ||
                                    detailcase.project_name ==
                                        'Thailand Post CAPOS' ||
                                    detailcase.project_name ==
                                        'Thailand POST_522565' ||
                                    detailcase.project_name ==
                                        'Thailand POST_202566' ||
                                    detailcase.project_name ==
                                        'Thailand POST_792566' ||
                                    detailcase.project_name ==
                                        'Thailand POST_942567'  ||
                                    detailcase.project_name ==
                                        'Thailand POST_932567'  ||
                                    detailcase.project_name ==
                                        'Thailand POST_1292568'
                            "
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    color
                                    fab
                                    small
                                    v-on="on"
                                    :to="
                                        '/Project/Nonhp/DocNonhp/' +
                                            item.maincase_id +
                                            '/' +
                                            item.subcase_id
                                    "
                                    target="_blank"
                                >
                                    <v-icon>mdi-fax</v-icon>
                                </v-btn>
                            </template>
                            <span>Print</span>
                        </v-tooltip>

                        <v-tooltip
                            top
                            v-if="
                                detailcase.project_name == 'OKI' ||
                                    team_name == 'OKI'
                            "
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    color
                                    fab
                                    small
                                    v-on="on"
                                    @click="printoki(detailcase.case_id)"
                                    target="_blank"
                                >
                                    <v-icon>mdi-fax</v-icon>
                                </v-btn>
                            </template>
                            <span>Print</span>
                        </v-tooltip>
                        <v-toolbar dense class="white elevation-0 ma-2">
                            <v-toolbar-title class="pr-3" v-if="detailcase.project_name == 'CDAX'">
                            <span class="primary--text">{{ item.subcase_wonumber }} </span>  
                            </v-toolbar-title>
                            <v-toolbar-title>
                                {{ item.subcase_title }}
                            </v-toolbar-title>

                            <v-spacer></v-spacer>
                            <v-chip class="ma-2">{{
                                item.sub_status_name
                            }}</v-chip>
                            <v-spacer></v-spacer>
                            <!-- <v-menu left bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        class="theme--light black--text"
                                    >
                                        <v-list-item-title>
                                            Edit Subcase
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
              </v-menu>-->
                            <!-- <v-btn
                v-if="status == 'ViewDetail'"
                small
                v-on="on"
                tile
                dark
                class="orange darken-1 ml-10"
                :to="
                  '/Project/' +
                    $route.params.team +
                    '/EditCase/' +
                    $route.params.caseid +
                    '/SUB/' +
                    item.subcase_id
                "
              >
                <v-icon small left>mdi-pencil</v-icon>Edit Sub Case
              </v-btn>-->
                        </v-toolbar>
                        <hr />
                        <v-row>
                            <v-col cols="4" sm="2" md="2">
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Site Name :</span
                                >
                            </v-col>
                            <v-col cols="8" sm="10" md="10">
                                <span>{{ item.site_name }}</span>
                            </v-col>

                            <v-col cols="4" sm="2" md="2">
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Site Address :</span
                                >
                            </v-col>
                            <v-col cols="8" sm="4" md="4">
                                <span>{{ item.site_address }}</span>
                            </v-col>
                            <v-col cols="4" sm="2" md="2">
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >CDAX Date Created :</span
                                >
                            </v-col>
                            <v-col cols="8" sm="4" md="4">
                                <span>{{ item.cdax_created }}</span>
                            </v-col>

                            <v-col cols="4" sm="2" md="2">
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Date Created :</span
                                >
                            </v-col>
                            <v-col cols="8" sm="10" md="10">
                                <span>{{ item.created_date }}</span>
                            </v-col>

                            <v-col cols="4" sm="2" md="2">
                                <span
                                    class="d-none d-sm-block font-weight-bold"
                                    style="margin-left: 15px"
                                    >Province / Engineer :</span
                                >
                                <span
                                    class="d-sm-none font-weight-bold"
                                    style="margin-left: 15px"
                                    >Provice / CE :</span
                                >
                            </v-col>
                            <v-col cols="8" sm="4" md="4">
                                <span
                                    >{{ item.branch_name }} /
                                    {{ item.engineer_name }}</span
                                >
                                <v-btn
                                    icon
                                    x-small
                                    @click="
                                        copy_engineer_name(
                                            item.engineer_name,
                                            item.engineer_hp_learnerid
                                        )
                                    "
                                >
                                    <v-icon x-small>mdi-content-copy</v-icon>
                                </v-btn>
                                <span
                                    >/#
                                    {{ item.engineer_hp_learnerid }}</span
                                >
                            </v-col>

                            <v-col cols="4" sm="2" md="2">
                                <span
                                    style="
                                        font-size: 13px;
                                        font-weight: bold;
                                        margin-left: 15px;
                                    "
                                    >Date Onsite :</span
                                >
                            </v-col>
                            <v-col cols="8" sm="4" md="4">
                                <span>
                                    {{ item.onsite_date }}
                                    ( {{ item.start_at }} ~ {{ item.stop_at }} )
                                </span>
                            </v-col>

                            <v-col cols="4" sm="2" md="2">
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Email :
                                </span>
                            </v-col>
                            <v-col cols="8" sm="4" md="4">
                                <span>{{ item.email }}</span>
                            </v-col>

                            <v-col cols="4" sm="2" md="2">
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >GPS at :</span
                                >
                            </v-col>
                            <v-col cols="8" sm="4" md="4">
                                <span style="margin-left: 0px">{{
                                    item.gps_date
                                }}</span>
                            </v-col>

                            <v-col cols="4" sm="2" md="2">
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >CSO NO :</span
                                >
                            </v-col>
                            <v-col cols="8" sm="4" md="4">
                                <span>{{ item.csono }}</span>
                            </v-col>

                            <v-col cols="4" sm="2" md="2">
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Solution :</span
                                >
                            </v-col>
                            <v-col cols="8" sm="10" md="4">
                                <span>{{ item.solution }}</span>
                            </v-col>
                            <v-col
                                v-if="item.schedule_range != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Schedule :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.schedule_range != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span>{{ item.schedule_range }}</span>
                            </v-col>
                            <v-col
                                v-if="item.printcount != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Print count :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.printcount != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span>{{ item.printcount }}</span>
                            </v-col>
                            <v-col
                                v-if="item.fid != null || item.fid_text != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >UEFI :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.fid != null || item.fid_text != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span
                                    >{{ item.fid }} - {{ item.fid_text }}</span
                                >
                            </v-col>

                            <v-col
                                v-if="item.kbank_sn != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Toner SN :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.kbank_sn != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span>{{ item.kbank_sn }}</span>
                            </v-col>

                            <v-col
                                v-if="item.kbank_percent != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >% remaining :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.kbank_percent != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span>{{ item.kbank_percent }}</span>
                            </v-col>

                            <v-col
                                v-if="item.kbank_page_remaining != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Page remaining :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.kbank_page_remaining != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span>{{ item.kbank_page_remaining }}</span>
                            </v-col>

                            <v-col
                                v-if="item.kbank_page_print != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Page count :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.kbank_page_print != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span>{{ item.kbank_page_print }}</span>
                            </v-col>

                            <v-col
                                v-if="item.sn_old != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Serial Old :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.sn_old != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span>{{ item.sn_old }}</span>
                            </v-col>

                            <v-col
                                v-if="item.sn_new != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Serial New :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.sn_new != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span>{{ item.sn_new }}</span>
                            </v-col>

                            <v-col
                                v-if="item.sameitem_no != null"
                                cols="4"
                                sm="2"
                                md="2"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    >Same Item No :</span
                                >
                            </v-col>
                            <v-col
                                v-if="item.sameitem_no != null"
                                cols="8"
                                sm="10"
                                md="4"
                            >
                                <span>{{ item.sameitem_no }}</span>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-container>
                                    <v-row>
                                        <view-image
                                            :title="
                                                'CSO ( ' +
                                                    item.cso.length +
                                                    ' )'
                                            "
                                            :data="item.csoimage"
                                            v-if="item.cso.length != 0"
                                        />
                                        <view-image
                                            cols="3"
                                            :title="
                                                'UEFI ( ' +
                                                    item.uefiimage.images
                                                        .length +
                                                    ' )'
                                            "
                                            :data="item.uefiimage"
                                            v-if="
                                                item.uefiimage.images.length !=
                                                    0
                                            "
                                        />
                                        <view-image
                                            :title="
                                                'UEFI_F ( ' +
                                                    item.uefifimage.images
                                                        .length +
                                                    ' )'
                                            "
                                            :data="item.uefifimage"
                                            v-if="
                                                item.uefifimage.images.length !=
                                                    0 && role_type != 'Engineer'
                                            "
                                        />
                                        <view-image
                                            :title="
                                                'ATTACH ( ' +
                                                    item.attachimage.images
                                                        .length +
                                                    ' )'
                                            "
                                            :data="item.attachimage"
                                            v-if="
                                                item.attachimage.images
                                                    .length != 0
                                            "
                                        />
                                        <v-chip
                                            class="mr-1 mb-1"
                                            v-if="item.e_cso == 'Y'"
                                            @click="get_pdf(item.subcase_id)"
                                            color="primary"
                                            small
                                        >
                                            <v-icon left small>mdi-file</v-icon>
                                            e-CSO
                                        </v-chip>

                                        <v-chip
                                            class="mr-1 mb-1"
                                            v-if="
                                                cso_sla_allowed_emp.includes(
                                                    emp_id
                                                )
                                            "
                                            @click="open_cso_sla_dialog(item.subcase_id, item.solution)"
                                            color="deep-purple accent-2"
                                            text-color="white"
                                            small
                                        >
                                            <v-icon left small>mdi-file</v-icon>
                                            e-CSO SLA
                                        </v-chip>

                                        <v-chip
                                            class="mr-1 mb-1"
                                            v-if="item.e_cso == 'Y'"
                                            :color="
                                                item.e_cso_status == NULL
                                                    ? 'red'
                                                    : item.e_cso_status == 'Y'
                                                    ? 'success'
                                                    : 'amber'
                                            "
                                            small
                                            @click="
                                                opendialog_resendemail(
                                                    item.email,
                                                    detailcase.customer_email
                                                ),
                                                    (dialog_resendemail = true)
                                            "
                                        >
                                            <v-icon left small>mdi-send</v-icon>
                                            Resend Email
                                        </v-chip>
                                    </v-row>
                                </v-container>
                            </v-col>
                        </v-row>
                        <!-- <v-row>
                            <v-col
                                cols="8"
                                sm="6"
                                md="4"
                                v-if="subcasedetail.length - 1 == index"
                            >
                                <span
                                    class="font-weight-bold"
                                    style="margin-left: 15px"
                                    ><label
                                        >ลูกค้าพอใจกับการบริการหรือไม่ (ช่าง)
                                        :</label
                                    ></span
                                >
                            </v-col>
                            <v-col
                                v-if="subcasedetail.length - 1 == index"
                                cols="4"
                                sm="6"
                                md="8"
                                style="margin-top: -15px"
                            >
                                <span style="margin-left: -30px">
                                    <v-btn
                                        v-if="
                                            detailcase.ce_customer_level == 'L'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1" color="red"
                                            >mdi-emoticon-sad</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            detailcase.ce_customer_level == 'M'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon
                                            class="display-1"
                                            color="amber darken-2"
                                            >mdi-emoticon-neutral</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            detailcase.ce_customer_level == 'H'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1" color="green"
                                            >mdi-emoticon-excited</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            detailcase.subs[0]
                                                .sub_status_name ==
                                                'Clear by Phone'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1" color="blue"
                                            >mdi-phone</v-icon
                                        >
                                    </v-btn>
                                </span>
                            </v-col>
                        </v-row> -->
                        <v-row style="margin-left: 5px">
                            <v-col cols="12" sm="6" md="4">
                                <span class="font-weight-bold">
                                    Doc Return Date :
                                    {{ item.doc_return_date }} /
                                    {{ item.doc_no }}
                                </span>
                            </v-col>

                            <v-col cols="12" sm="6" md="4">
                                <span class="font-weight-bold"
                                    >Doc Status :
                                    {{ item.doc_status }}
                                </span>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <span class="font-weight-bold"
                                    >Doc Received :
                                    {{ item.doc_date }}
                                    / {{ item.doc_name }}
                                </span>
                            </v-col>
                        </v-row>
                        <!-- <v-col cols="12" sm="2" md="2">
                                <span class="font-weight-bold"
                                    >Closed By :</span
                                >
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <span>{{ item.closed_by }}</span>
              </v-col>-->
                        <v-row justify="center">
                            <v-form
                                ref="form"
                                method="post"
                                id="nativeForm"
                                v-model="valid"
                            >
                                <v-dialog
                                    v-model="dialog_resendemail"
                                    scrollable
                                    max-width="400px"
                                >
                                    <v-card>
                                        <v-card-title
                                            >Resend Email</v-card-title
                                        >
                                        <v-divider></v-divider>
                                        <v-card-text
                                            style="
                                                height: 100px;
                                                margin-top: 5px;
                                            "
                                        >
                                            <v-row>
                                                <v-col>
                                                    <v-text-field
                                                        label="Send To Email"
                                                        v-model="send_to_email"
                                                        :rules="[
                                                            (v) =>
                                                                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                                                    v
                                                                ) ||
                                                                'E-mail must be valid',
                                                        ]"
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="
                                                    dialog_resendemail = false
                                                "
                                            >
                                                Close
                                            </v-btn>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                :disabled="!valid"
                                                @click="
                                                    confirm_send_to_email(
                                                        item.subcase_id
                                                    )
                                                "
                                            >
                                                Save
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-form>
                        </v-row>
                        <div class="text-center">
                            <v-dialog
                                v-model="dialog_loadings"
                                hide-overlay
                                persistent
                                width="300"
                            >
                                <v-card color="primary" dark>
                                    <v-card-text>
                                        Download-Cso
                                        <v-progress-linear
                                            indeterminate
                                            color="white"
                                            class="mb-0"
                                        ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </div>
                        <v-dialog
                            v-model="dialog_cso_sla"
                            scrollable
                            max-width="700px"
                        >
                            <v-card>
                                <v-card-title>e-CSO SLA</v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="pt-6">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-menu
                                                v-model="cso_sla_date_menu"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <v-text-field
                                                        v-model="cso_sla_date"
                                                        label="Date"
                                                        placeholder="M/D/YYYY"
                                                        hint="e.g. 9/4/2026"
                                                        append-icon="mdi-calendar"
                                                        dense
                                                        outlined
                                                        @click:append="
                                                            cso_sla_date_menu = true
                                                        "
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="cso_sla_date"
                                                    no-title
                                                    @input="
                                                        cso_sla_date_menu = false
                                                    "
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-menu
                                                v-model="cso_sla_start_menu"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <v-text-field
                                                        v-model="cso_sla_start"
                                                        label="Start"
                                                        placeholder="H:MM AM/PM"
                                                        hint="e.g. 9:00 AM"
                                                        append-icon="mdi-clock-time-four-outline"
                                                        dense
                                                        outlined
                                                        @click:append="
                                                            cso_sla_start_menu = true
                                                        "
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="cso_sla_start_menu"
                                                    v-model="cso_sla_start"
                                                    full-width
                                                    format="24hr"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="
                                                            cso_sla_start_menu = false
                                                        "
                                                    >
                                                        OK
                                                    </v-btn>
                                                </v-time-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-menu
                                                v-model="cso_sla_finish_menu"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            cso_sla_finish
                                                        "
                                                        label="Finish"
                                                        placeholder="H:MM AM/PM"
                                                        hint="e.g. 2:00 PM"
                                                        append-icon="mdi-clock-time-four-outline"
                                                        dense
                                                        outlined
                                                        @click:append="
                                                            cso_sla_finish_menu = true
                                                        "
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="cso_sla_finish_menu"
                                                    v-model="cso_sla_finish"
                                                    full-width
                                                    format="24hr"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="
                                                            cso_sla_finish_menu = false
                                                        "
                                                    >
                                                        OK
                                                    </v-btn>
                                                </v-time-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-model="cso_sla_solution"
                                                label="Solution"
                                                placeholder="e.g. VNF2K02379 - WUR 3 Current Unit"
                                                dense
                                                outlined
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="dialog_cso_sla = false"
                                    >
                                        Close
                                    </v-btn>
                                    <v-btn
                                        color="blue"
                                        dark
                                        :disabled="
                                            !cso_sla_date ||
                                                !cso_sla_start ||
                                                !cso_sla_finish
                                        "
                                        @click="save_cso_sla()"
                                    >
                                        Download e-CSO SLA
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-text>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>
<script>
let url = `${process.env.VUE_APP_ROOT_API}/api/`
import axios from "axios"
import Image from "../../../components/ViewImage"
import _ from "lodash"
import { mapState, mapMutations } from "vuex"
export default {
    computed: {},
    components: {
        "view-image": Image,
    },
    props: ["detailcase", "status", "active_tab"],
    data() {
        return {
            valid: false,
            send_to_email: "",
            dialog_resendemail: false,
            dialog_loadings: false,
            dialog_cso_sla: false,
            cso_sla_subcase_id: null,
            cso_sla_date_menu: false,
            cso_sla_date: null,
            cso_sla_start_menu: false,
            cso_sla_start: null,
            cso_sla_finish_menu: false,
            cso_sla_finish: null,
            cso_sla_solution: null,
            role_type: localStorage.role_type,
            team_name: localStorage.team_name,
            emp_id: localStorage.emp_img,
            cso_sla_allowed_emp: [
                "P16-021",
                "P09-017",
                "P11-039",
                "P10-303",
                "P03-177",
                "A17-003",
                "P19-063",
                "P24-007",
            ],
            // active_tab: 1,
            subcasedetail: [],
            showpic1: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,
            cso: {
                csoimage: {
                    images: [],
                },
            },
            uefi: {
                uefiimage: {
                    images: [],
                },
            },
            uefif: {
                uefifimage: {
                    images: [],
                },
            },
            attach: {
                attachimage: {
                    images: [],
                },
            },
        }
    },
    watch: {
        detailcase: function(val) {
            _.delay(this.getImage, 500)
        },
        dialog_loadings(val) {
            if (!val) return

            setTimeout(() => (this.dialog_loadings = false), 5000)
        },
    },
    mounted() {
        _.delay(this.getImage, 500)
        // console.log('---------sub 1',this.detailcase.subs[0].subcase_title)
        // console.log('---------sub 2',this.detailcase.subs[1].subcase_title)

    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        confirm_send_to_email(subcase) {
            this.$swal({
                title: "Send To Email ?",
                text: this.send_to_email,
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    this.save_send_to_email(subcase)
                }
            })
        },
        async save_send_to_email(subcase) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/hpi/resend-email`
            // console.log(url);
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            var send = {
                subcase_id: subcase,
                email: this.send_to_email,
            }
            try {
                this.mutateIsLoading()
                const { data } = await axios.post(url, send, options)
                this.$swal("ส่งข้อมูลเรียบร้อยครับ.", {
                    icon: "success",
                    button: false,
                    timer: 1000,
                })
                // console.log(data);

                this.mutateIsLoading()
                this.dialog_resendemail = false
            } catch (error) {
                console.log(error)
            }
        },

        copy_engineer_name(engineer_name, engineer_hp_learnerid) {
            navigator.clipboard.writeText(
                engineer_name + " " + engineer_hp_learnerid
            )
            this.$swal("Copied!", {
                icon: "success",
                button: false,
                timer: 800,
            })
        },
        opendialog_resendemail(email, email1) {
            if (email != "" && email != undefined && email != null) {
                this.send_to_email = email
            } else if (email1 != "" && email1 != undefined && email1 != null) {
                this.send_to_email = email1
            }
        },
        async get_pdf(id) {
            this.dialog_loadings = true
            await axios({
                url: url + "hpi/download-cso/" + id,
                responseType: "arraybuffer",
            }).then((response) => {
                // let blob = new Blob([response.data], {
                //     type: "application/pdf",
                //   }),

                //   url = window.URL.createObjectURL(blob);

                // window.open(url);
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")
                let file_namex =
                    this.detailcase.case_id +
                    "-" +
                    this.detailcase.subcase +
                    ".pdf"
                fileLink.href = fileURL
                fileLink.setAttribute("download", file_namex)
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        open_cso_sla_dialog(id, solution) {
            this.cso_sla_subcase_id = id
            this.cso_sla_date = null
            this.cso_sla_start = null
            this.cso_sla_finish = null
            this.cso_sla_solution = solution || null
            this.dialog_cso_sla = true
        },
        parse_time(time) {
            if (!time) return null
            const cleaned = time.trim().replace(/\./g, ":")
            const match = cleaned.match(
                /^(\d{1,2}):(\d{2})(?::\d{2})?\s*([AaPp][Mm])?$/
            )
            if (!match) return null
            let hour = parseInt(match[1], 10)
            const minute = parseInt(match[2], 10)
            const ampm = match[3] ? match[3].toUpperCase() : null
            if (ampm === "PM" && hour < 12) hour += 12
            if (ampm === "AM" && hour === 12) hour = 0
            return { hour, minute }
        },
        combine_date_time(date, time) {
            const d = new Date(date)
            const parsedTime = this.parse_time(time)
            if (isNaN(d) || !parsedTime) return ""
            const pad = (n) => String(n).padStart(2, "0")
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
                d.getDate()
            )} ${pad(parsedTime.hour)}:${pad(parsedTime.minute)}`
        },
        async save_cso_sla() {
            const send = {
                subcase_id: this.cso_sla_subcase_id,
                start: this.combine_date_time(
                    this.cso_sla_date,
                    this.cso_sla_start
                ),
                finish: this.combine_date_time(
                    this.cso_sla_date,
                    this.cso_sla_finish
                ),
                solution: this.cso_sla_solution,
            }
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
                responseType: "arraybuffer",
            }
            try {
                this.dialog_loadings = true
                const response = await axios.post(
                    url + "hpi/download-cso-2",
                    send,
                    options
                )
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")
                let file_namex =
                    this.detailcase.case_id +
                    "-" +
                    this.detailcase.subcase +
                    ".pdf"
                fileLink.href = fileURL
                fileLink.setAttribute("download", file_namex)
                document.body.appendChild(fileLink)

                fileLink.click()
                this.dialog_cso_sla = false
                this.dialog_loadings = false
            } catch (error) {
                this.dialog_loadings = false
                console.log(error)
            }
        },
        printoki(caseid) {
            window.open(
                `https://www.aittservice.com/okicrm/frmOrder.php?csoID=${caseid}`,
                "newwindow",
                "width=1500,height=700,scrollbars=yes,titlebar=no,left=250"
            )
        },
        getImage() {
            this.subcasedetail = []

            this.detailcase.subs.map((each) => {
             console.log('each', each)
                this.cso = {
                    csoimage: {
                        images: [],
                    },
                }
                this.uefi = {
                    uefiimage: {
                        images: [],
                    },
                }
                this.uefif = {
                    uefifimage: {
                        images: [],
                    },
                }
                this.attach = {
                    attachimage: {
                        images: [],
                    },
                }
                if (
                    each.cso.length != 0 ||
                    each.uefi.length != 0 ||
                    each.attach.length != 0
                ) {
                    each.cso.map((res1) => {
                        this.cso.csoimage.images.push(
                            this.showpic1 + res1.file_id
                        )
                    })
                    each.uefi.map((res2) => {
                        this.uefi.uefiimage.images.push(
                            this.showpic1 + res2.file_id
                        )
                    })
                    each.uefi_f.map((res2) => {
                        this.uefif.uefifimage.images.push(
                            this.showpic1 + res2.file_id
                        )
                    })
                    each.attach.map((res2) => {
                        this.attach.attachimage.images.push(
                            this.showpic1 + res2.file_id
                        )
                    })
                    this.subcasedetail.push(
                        Object.assign(
                            {},
                            each,
                            this.cso,
                            this.uefi,
                            this.uefif,
                            this.attach
                        )
                    )
                } else {
                    this.subcasedetail.push(
                        Object.assign(
                            {},
                            each,
                            this.cso,
                            this.uefi,
                            this.uefif,
                            this.attach
                        )
                    )
                }
            })
            // console.log(this.subcasedetail, "sds");
        },
    },
}
</script>
